import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../environments/environment';

const apiBaseUrl = environment.apiUrl;
const rinhoCmdApi = environment.rinhoCmdApi;
const httpOptions = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Basic amJyaXRvczpUZWNuaWNvMTU=' } };
const httpOptionsApiRinho = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Basic amJyaXRvczpUZWNuaWNvMTU=' } };

@Injectable({
  providedIn: 'root',
})
export class PlockapiService {


  constructor(private _client: HttpClient) { }

  getRinhoDevices(userId: string): Observable<any> {
    return this._client.get(apiBaseUrl + 'Pema/GetPemasRinho/'+userId, httpOptions);
  }

  getChatHistory(id: number): Observable<any> {
    return this._client.get(apiBaseUrl + 'Pema/GetHistoricoCmds/' + id, httpOptions);
  }

  sendMessage(cmd: string): Observable<any> {
    return this._client.post(rinhoCmdApi, JSON.stringify(cmd), httpOptionsApiRinho);
  }

  authenticateUser(usr: any): Observable<any> {
    let finalUrl = apiBaseUrl + 'Usuario/Autenticar'
    return this._client.post(finalUrl, usr, httpOptions);
  }

  //post method for sending the commands
  getAppVersion(): Observable<any> {
    return this._client.get(apiBaseUrl + 'versions/TERMINALCMD', httpOptions);
  }
}
